import React from 'react';
import styles from './style.css';
import Heading from '../Typography/Heading/Heading';

const TransferInstitutionHeader = () => {
  const headingCopy =
    "Select the institution that holds the account you'd like to transfer";

  return (
    <div className="build-institution-header" id="build-institution-header">
      <Heading text={headingCopy} />
      <style jsx>{styles}</style>
    </div>
  );
};

export default TransferInstitutionHeader;
